import { a as _objectSpread2 } from '../_rollupPluginBabelHelpers-1f0bf8c2.js';
import { createComponent } from 'reakit-system/createComponent';
import { createHook } from 'reakit-system/createHook';
import 'reakit-utils/shallowEqual';
import { useBox } from '../Box/Box.js';
import 'react';
import 'reakit-utils/useLiveRef';
import 'reakit-utils/useSealedState';
import '../Id/IdProvider.js';
import '../Id/IdState.js';
import 'reakit-utils/useUpdateEffect';
import 'reakit-utils/isPromise';
import 'reakit-utils/isEmpty';
import 'reakit-utils/isPlainObject';
import { unstable_useFormState } from './FormState.js';
import 'reakit-utils/isObject';
import './utils/setAllIn.js';
import './utils/getIn.js';
import 'reakit-utils/toArray';
import 'reakit-utils/isInteger';
import './utils/setIn.js';
import { g as getInputId } from '../getInputId-aa144169.js';
import { g as getLabelId } from '../getLabelId-3db05e97.js';

var unstable_useFormLabel = createHook({
  name: "FormLabel",
  compose: useBox,
  useState: unstable_useFormState,
  keys: ["name", "label"],
  useProps: function useProps(options, htmlProps) {
    return _objectSpread2({
      children: options.label,
      id: getLabelId(options.name, options.baseId),
      htmlFor: getInputId(options.name, options.baseId)
    }, htmlProps);
  }
});
var unstable_FormLabel = createComponent({
  as: "label",
  memo: true,
  useHook: unstable_useFormLabel
});

export { unstable_FormLabel, unstable_useFormLabel };
